export default "__VITE_ASSET__CNlYRc5___"